import {Provider, useDispatch} from "react-redux";
import {setComplexId, setTheme, setToggleChecked, store} from "@cabinet-packages/redux";
import {ConfirmDialog, CustomDialog} from "@cabinet-packages/components";
import {makeStyles, Snackbar, ThemeProvider} from "@material-ui/core";
import themeMaterialUI from "./settings/themeMaterialUI";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import uk_utils from "date-fns/locale/uk";
import React, {useEffect, useState} from "react";
import LandingPage from "./LandingPage";
import {isLogin} from "@cabinet-packages/helpers"
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom'
import routes from "./settings/routes";
import {AppStateProvider} from "@cabinet-packages/hooks";
import {setActionImg, setTakeId} from "@cabinet-packages/redux/actions/actionsCreators";
import withClearCache from "./ClearCache";
import actionIMG from './assets/images/promotionImages/action.jpg'
import PageNotFound from "./pages/PageNotFound";
import {Alert} from "@material-ui/lab";
import Button from "@material-ui/core/Button";
import {useHistory} from "react-router";
import moment from "moment";


const useStyles = makeStyles(theme => ({
    alertSnackbar: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginLeft: '-24px',
    }
}));

const ClearCacheComponent = withClearCache(AppWrapper);

function ClearCacheApp() {
    return <ClearCacheComponent />;
}

function App () {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const history = useHistory();
    const infoMessage = localStorage.getItem('infoMessage');
    const idReg = localStorage.getItem('idReg');

    const handleCookiesInfoMessageConfirm = (event) => {
        event.stopPropagation();
        event.preventDefault();

        localStorage.setItem('infoMessage', moment().format('YYYY-MM-DD'));
        setOpen(false);
    }

    useEffect( ()=> {
        dispatch(setTakeId(200));
        dispatch(setComplexId(230));
        dispatch(setTheme(themeMaterialUI));
        dispatch(setActionImg(actionIMG));
        dispatch(setToggleChecked(true));
        // if (localStorage.getItem('activePatient') && !isLogin()) localStorage.removeItem('activePatient');
        // if (localStorage.getItem('activePatientPhone') && !isLogin()) localStorage.removeItem('activePatientPhone');
        // if (!localStorage.getItem('activePatientPhone') && AccessKey.get()) AccessKey.remove();
    }, [dispatch]);

    // useEffect(() => {
    //     if (!infoMessage && history.location.pathname !== '/covidPCR') {
    //         setOpen(true);
    //     } else {
    //         setOpen(false);
    //     }
    // }, []);

    useEffect(() => {
        localStorage.setItem('idReg', '32');
    }, [])

    useEffect(() => {
        if (infoMessage) {
            if (!moment(infoMessage, 'YYYY-MM-DD').isValid()
                || moment(infoMessage, 'YYYY-MM-DD')
                    .add(1, 'days')
                    .isBefore(moment(moment().format('YYYY-MM-DD')))) {
                localStorage.removeItem('infoMessage');
            }
        }
    },[]);

    return <ThemeProvider theme={themeMaterialUI}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={uk_utils}>
            <Switch>
                <Route path={"/"} exact>
                    {isLogin()
                        ? <Redirect to={"/patient-results"}/>
                        : <Redirect to={"/auth"}/>}
                </Route>
                {isLogin() && <Route path={"/auth"} exact>
                    <Redirect to={"/patient-results"}/>
                </Route>}
                {routes.map((route, index) => {
                    return route.underAuth
                        ? <Route
                            key={index}
                            path={route.path}
                            render={props => (isLogin()
                                ? <LandingPage {...props} />
                                : <Redirect to={"/auth"}/>)
                            }
                        />
                        : <Route
                            key={index}
                            path={route.path}
                            render={props => (<route.component {...props} />)}
                        />})
                }
                <Route>
                    <PageNotFound />
                </Route>
            </Switch>
            <Snackbar
                autoHideDuration={6000}
                onClose={() => setOpen(false)}
                open={open}
                action={<div className={classes.alertSnackbar}>
                    <Alert severity="info">
                        В особистому кабінеті ми запустили сервіс ОН-ЛАЙН замовлення.
                        Перейдіть на сторінку "Перелік досліджень" для створення та оплати замовлення.
                    </Alert>
                    <Button
                        color="primary"
                        size="small"
                        variant="contained"
                        style={{marginTop: '4px'}}
                        onClick={handleCookiesInfoMessageConfirm}
                    >
                        зрозуміло
                    </Button>
                </div>}
            >
            </Snackbar>
        </MuiPickersUtilsProvider>
    </ThemeProvider>
}

function AppWrapper () {
    return (<ThemeProvider theme={themeMaterialUI}>
            <Provider store={store}>
                <BrowserRouter getUserConfirmation={(message, callback) => {
                    CustomDialog(ConfirmDialog, {
                        onConfirm: () => callback(true),
                        onCancel: () => callback(false),
                        text: message,
                    }, false, themeMaterialUI);
                }}>
                    <AppStateProvider>
                        <App/>
                    </AppStateProvider>
                </BrowserRouter>
            </Provider>
        </ThemeProvider>
    )
}

export default ClearCacheApp;
